import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import _ from "lodash";
import { KEY_PRODUCT_KIND, KEY_SIZE, KEY_THICK } from "../../common/constant";
import { filterOptions } from "../../services";
import { useTranslation } from "react-i18next";

const FilterItemModal = (props: any, ref: any) => {
  const {
    currentFilter,
    closeModal,
    handleClickNextOrPrev,
    handleFilter,
    currentFilters,
    filterOptionList,
    isMobile,
    productOptions,
  } = props;
  const { t } = useTranslation();
  const [result, setResult] = useState<any>({});
  const [filters, setFilters] = useState<any>({});
  const [newFilterOptionChilds, setNewFilterOptionChilds] = useState<any>([]);
  const [unCheck, setUnCheck] = useState<any>({
    size: false,
    thick: false,
    id: false,
  });

  useImperativeHandle(ref, () => ({
    getFilterOptionData,
  }));

  useEffect(() => {
    if (isMobile) {
      if (currentFilters && currentFilters[t("detail_query")]) {
        filterOptions.getFilterOptionChilds(
          {
            filters: {
              category_ids: getCatIdBySlug(
                productOptions,
                currentFilters[t("detail_query")]
              ),
            },
          },
          (data: any, err: any) => {
            if (data && data.docs && data.docs.length) {
              const _newFilters = mappingNewOptionChildsToOldOptionChilds(
                data.docs,
                currentFilter
              );
              setNewFilterOptionChilds(_newFilters);
              setResult(getDataResult(_newFilters));
            } else {
              setNewFilterOptionChilds(currentFilter);
            }
          }
        );
      } else {
        setNewFilterOptionChilds(currentFilter);
      }
    }
  }, []);

  useEffect(() => {
    setResult(getDataResult(currentFilter));
  }, [currentFilter]);

  useEffect(() => {
    if (Object.keys(currentFilters).length) {
      setFilters(_.extend(filters, currentFilters));
    }
  }, [currentFilters]);

  const getDataResult = (objects: any) => {
    const currFilters = {};
    objects.forEach((item: any) => {
      const currFiltersTemp = getCurrentFilters(item.values);

      _.extend(currFilters, {
        [item.code]: currFiltersTemp.length ? currFiltersTemp[0].code : null,
      });
    });
    return currFilters;
  };

  const getCatIdBySlug = (objects: any, slug: string) => {
    const rs = objects.filter(
      (obj: any) => obj.slug == slug || obj.slug_en == slug
    );

    if (!rs || !rs.length) {
      return null;
    }

    return rs[0].cat_id;
  };

  const getFilterOptionData = (id: string, cb: Function) => {
    if (filters && filters[t("detail_query")]) {
      filterOptions.getFilterOptionChild(
        {
          filter_option_parent_id: id,
          category_ids:
            filters.id ||
            getCatIdBySlug(productOptions, filters[t("detail_query")]),
        },
        (data: any, err: any) => {
          if (data) {
            cb(data.values);
          } else {
            cb(null);
          }
        }
      );
    } else {
      cb(null);
    }
  };

  const getCurrentFilters = (data: any) => {
    return data.filter((d: any) => {
      if (d.value.wide && d.value.long && !unCheck.size) {
        return (
          d.value.wide === parseInt(filters?.wide || currentFilters?.wide) &&
          d.value.long === parseInt(filters?.long || currentFilters?.long)
        );
      } else if (d.value.thick && !unCheck.thick) {
        return (
          d.value.thick === parseInt(filters?.thick || currentFilters?.thick)
        );
      } else if (d.value[t("detail_query")] && !unCheck.id) {
        return (
          d.value[t("detail_query")] ===
          (filters[t("detail_query")] || currentFilters[t("detail_query")])
        );
      }
    });
  };

  const mappingNewOptionChildsToOldOptionChilds = (
    newOptionChilds: any,
    oldOptionChilds: any
  ) => {
    let _temp = oldOptionChilds;

    newOptionChilds.forEach((item: any) => {
      const tempIndex = _temp.findIndex(
        (obj: any) => obj._id === item.filter_option_parent_id
      );
      _temp[tempIndex].values = item.values;
    });

    return _temp;
  };

  const handleChange = (e: any) => {
    if (isMobile && e.target.name === KEY_PRODUCT_KIND) {
      filterOptions.getFilterOptionChilds(
        {
          filters: { category_ids: e.target.value },
        },
        (data: any, err: any) => {
          if (data && data.docs && data.docs.length) {
            setNewFilterOptionChilds(
              mappingNewOptionChildsToOldOptionChilds(
                data.docs,
                newFilterOptionChilds
              )
            );
          } else {
            let _currentFilter = currentFilter.map((item: any) => ({
              ...item,
              values: item.default_values,
            }));

            setNewFilterOptionChilds(_currentFilter);
          }

          setResult({ ...result, [e.target.name]: e.target.value });
          setFilters(
            _.extend(
              filters,
              currentFilter
                .filter((c: any) => c.code === e.target.name)[0]
                ?.values.filter((d: any) => d.code === e.target.value)[0]?.value
            )
          );
        }
      );
    } else {
      setResult({ ...result, [e.target.name]: e.target.value });
      setFilters(
        _.extend(
          filters,
          currentFilter
            .filter((c: any) => c.code === e.target.name)[0]
            ?.values.filter((d: any) => d.code === e.target.value)[0]?.value
        )
      );
    }
  };

  const handleClickResult = (e: any) => {
    e.preventDefault();
    closeModal();
    delete filters.id;
    handleFilter(filters);
  };

  const handleClickNextPrev = (e: any, item: any, step: number) => {
    e.preventDefault();
    const _filterOption = filterOptionList.filter(
      (f: any) => f.order === item[0].order + step
    );

    if (
      _filterOption &&
      _filterOption.length &&
      _filterOption[0].code != KEY_PRODUCT_KIND
    ) {
      getFilterOptionData(_filterOption[0]._id, (data: any) => {
        handleClickNextOrPrev(item[0].order, step, data);
      });
    } else {
      handleClickNextOrPrev(item[0].order, step);
    }
  };

  const handleClearFilter = (e: any) => {
    e.preventDefault();
    setFilters({});
    setResult({});
  };

  const handleUnChecked = (e: any) => {
    const currValue = result[e.target.name];

    if (currValue && currValue === e.target.value) {
      setResult({ ...result, [e.target.name]: "" });
      const currFilters = { ...filters };

      switch (e.target.name) {
        case KEY_PRODUCT_KIND:
          setUnCheck({ ...unCheck, id: true });
          delete currFilters[t("detail_query")];
          break;
        case KEY_THICK:
          setUnCheck({ ...unCheck, thick: true });
          delete currFilters.thick;
          break;
        case KEY_SIZE:
          setUnCheck({ ...unCheck, size: true });
          delete currFilters.long;
          delete currFilters.wide;
          break;

        default:
          break;
      }

      setFilters(currFilters);
    } else {
      switch (e.target.name) {
        case KEY_PRODUCT_KIND:
          setUnCheck({ ...unCheck, id: false });
          break;
        case KEY_THICK:
          setUnCheck({ ...unCheck, thick: false });
          break;
        case KEY_SIZE:
          setUnCheck({ ...unCheck, size: false });
          break;

        default:
          break;
      }
    }
  };

  const getDataByDevice = () =>
    isMobile ? newFilterOptionChilds : currentFilter;

  const showOptions = (data: any) =>
    data.map((d: any) => (
      <Radio
        value={d.code}
        key={d.code}
        className="filter-option"
        onClick={(e: any) => handleUnChecked(e)}>
        <div className="option-content">
          <img src={d.img ? d.img.path : ""} alt="" />
          <span className="main-content">{d.name || ""}</span>
        </div>
      </Radio>
    ));

  const showFilters = () =>
    getDataByDevice().map((c: any, i: number) => (
      <div className="kd-filter-wrap" key={i}>
        <div className="kd-filter-title-wrap">
          <span className="filter-name sub-title">{c.name}</span>
          {c.description ? (
            <span className="filter-description sub-title">
              <div
                dangerouslySetInnerHTML={{
                  __html: c.description.replace(
                    "18009053",
                    "<a href='tel:18009053'>18009053</a>"
                  ),
                }}></div>
            </span>
          ) : null}
        </div>
        <div
          className={`filter-options ${
            c.code === KEY_THICK
              ? "thick-options"
              : c.code === "utility"
              ? "utility-options"
              : c.code === KEY_SIZE
              ? "size-options"
              : ""
          }`}>
          <Radio.Group
            onChange={handleChange}
            name={c.code}
            value={result[c.code]}>
            {c.code === KEY_THICK ? (
              <img
                src={c.img ? c.img.path : ""}
                alt=""
                className="thick-form"
              />
            ) : null}
            {showOptions(_.sortBy(c.values, ["order", "position"]))}
          </Radio.Group>
        </div>
      </div>
    ));

  return (
    <div className="kd-filter-modal-wrap">
      {isMobile ? (
        <div className="filter-label main-title">
          <span>Bộ lọc tìm kiếm</span>
        </div>
      ) : null}
      <div className="filters-wrap">{showFilters()}</div>
      <div className="action-group">
        <div>
          <a
            className="clear-filter-btn"
            onClick={(e: any) => handleClearFilter(e)}>
            Thiết lập lại
          </a>
        </div>
        <div>
          {currentFilter.length && currentFilter[0].order > 1 ? (
            <a
              className="continue-btn"
              onClick={(e: any) => handleClickNextPrev(e, currentFilter, -1)}>
              <CaretLeftOutlined />
              <CaretLeftOutlined />
              &nbsp;
              <span className="main-content">Quay lại</span>
            </a>
          ) : null}
          <a
            className="result-btn main-content"
            onClick={(e: any) => handleClickResult(e)}>
            {isMobile ? "Áp dụng" : "Xem kết quả"}
          </a>
          {currentFilter.length &&
          currentFilter[0].order < filterOptionList.length ? (
            <a
              className="continue-btn"
              onClick={(e: any) => handleClickNextPrev(e, currentFilter, 1)}>
              <span className="main-content">Tiếp</span>&nbsp;
              <CaretRightOutlined />
              <CaretRightOutlined />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default forwardRef(FilterItemModal);
